import React, {useEffect, useState, Fragment, useMemo} from 'react';
import {
  Link,
  NavLink
} from "react-router-dom";

import { Popover, Transition } from '@headlessui/react';
import { connect } from 'react-redux';
import { NavHashLink } from 'react-router-hash-link';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import {ChevronDownIcon, XMarkIcon} from '@heroicons/react/20/solid'
import { BookmarkSquareIcon, CalendarIcon, ShieldCheckIcon, LifebuoyIcon, AcademicCapIcon } from '@heroicons/react/24/outline'

import { useRouteMatch, useLocation, useResolvedPath } from "react-router-dom";


const messages = [
  {
    persona: 'payroll-bureau/',
    title: 'New Release: CIS 300',
    // cta: 'Learn More',
    description: 'CIS Contractor verification and CIS 300 submission available starting April 2025.',
    // href: 'https://www.payrollgrowthsummit.com/?utm_source=Website&utm_medium=banner&utm_campaign=Payroll+Summit+LP',
    jurisdiction: ['uk'],
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function MarketingBanner({
  profile,
  loggedIn,
  recentPosts,
  marketingFilters,
  hiddenFilters,
}) {
  let location = useLocation();

  const countryCode = location.pathname.split('/')[1]
  const country = ['uk', 'mt', 'ie'].includes(countryCode) ? '/' + countryCode + '/' : ''

  const personaSlug = location.pathname.split('/')[2]
  const persona = ['employee', 'employer', 'payroll-bureau'].includes(personaSlug) ? personaSlug + '/' : 'employer/'

  const [message, setMessage] = useState(null)
  const [dismissed, setDismissed] = useState([])

  useEffect(() => {
	  console.log('persona', persona, 'message.persona', messages[0].persona)
    const filtered = messages.filter(message =>{
		return message.jurisdiction.includes(countryCode) &&
		(!persona || persona === message.persona) &&
		!dismissed.includes(message)
	}
	)
	  console.log('filtered persona', filtered)

	  setMessage(filtered[0])
  }, [country,persona,dismissed]);

  if (!message) {
    return null
  }

  return (

    <div className="pointer-events-none fixed inset-x-0 bottom-0 sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8 z-50">
		<div className="pointer-events-auto flex items-center justify-between gap-x-6 bg-orange-600 px-6 py-2.5 sm:rounded-xl sm:py-3 sm:pl-4 sm:pr-3.5">
		  <p className="text-sm/6 text-white">
			<a href={message.href}>
			  <strong className="font-semibold">{message.title}</strong>
			  <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline size-0.5 fill-current">
				<circle r={1} cx={1} cy={1} />
			  </svg>
				{message.description}
				{message.cta &&
					<>
					  	<svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline size-0.5 fill-current">
							<circle r={1} cx={1} cy={1} />
					  	</svg>
						{message.cta}&nbsp;
					</>
				}
				&nbsp;<span aria-hidden="true">&rarr;</span>
			</a>
		  </p>
		  <button type="button" className="-m-1.5 flex-none p-1.5"
		  	onClick={e => {
				e.preventDefault()
				setMessage(null)
				setDismissed([...dismissed, message])
			}}
		  >
			<span className="sr-only">Dismiss</span>
			<XMarkIcon aria-hidden="true" className="size-5 text-white" />
		  </button>
		</div>
	</div>
  );
}

const mapStateToProps = (state, ownProps) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    loggedIn: state.my.profile ? true : false,
    profile: state.my.profile,
    recentPosts: state.articles && state.articles.slice(0, 3),
    marketingFilters: state.navBarOverride.marketing,
    hiddenFilters: state.navBarOverride.hide,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarketingBanner)
